import { createSlice } from "@reduxjs/toolkit";

const initialPublicNotice = {
  definition: "",
  explanation: ""
};

const initialPublicNoticesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  publicNotice: initialPublicNotice
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const publicNoticeSlice = createSlice({
  name: "publicNotices",
  initialState: initialPublicNoticesState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getPublicNotices
    publicNoticesFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    //getPublicNoticeDetail
    publicNoticeFetched: (state, action) => {
      state.actionsLoading = false;
      state.isSuccess = action.payload.isSuccess;
      state.type = action.payload.type;
      state.publicNotice = action.payload.entity;
    },
    //completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    //cleanPublicNoticesState
    publicNoticesStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.entities = undefined;
      state.totalCount = 0;
      state.publicNotice = initialPublicNotice;
    }
  }
});